import { Footer } from '@cfra-nextgen-frontend/shared/src/components/Footer';
import { Box } from '@mui/material';
import { ChartReaderPage } from 'features/chartReader/components/ChartReaderPage';
import { pageWithFooterSx } from 'features/chartReader/styles/chartReader.styles';
import { Navigate, Route, Routes } from 'react-router-dom';

export function ChartReaderPageRoutes() {
    return (
        <Routes>
            <Route path='/*' element={<Navigate to='.' replace />} />
            <Route
                path='/'
                element={
                    <Box sx={pageWithFooterSx}>
                        <ChartReaderPage />
                        <Footer size='compact' hideBackToTop />
                    </Box>
                }
            />
        </Routes>
    );
}
